import 'babel-polyfill'//es6转es5兼容ie
import 'url-search-params-polyfill';//让ie支持URLSearchParams
import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import Vant from 'vant';
import 'vant/lib/index.css';
import config from './assets/js/conf/config.js';
import IsPC from "./assets/js/libs/IsPc.js";
import refreshToken from "./assets/js/libs/refreshToken.js";
import getUserInfo from "./assets/js/libs/getUserInfo.js";
import {network} from './assets/js/libs/network.js';
import {Row, Col, Pagination, Button, Table, TableColumn, Icon, Loading, RadioGroup, Radio, Checkbox, CheckboxGroup, Dialog, Form,FormItem, Input, Popconfirm, MessageBox, Message, Autocomplete, Progress, Select, Option, Backtop, DatePicker} from 'element-ui';
import { message} from "./assets/js/libs/message"  //防止单击多次提交多次
Vue.use(Vant)
Vue.use(Row);
Vue.use(Col);
Vue.use(Pagination);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Icon);
Vue.use(Loading);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatePicker);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(Input);
Vue.use(FormItem);
Vue.use(Popconfirm);
Vue.use(Autocomplete);
Vue.use(Progress);
Vue.use(Select);
Vue.use(Option);
Vue.use(Backtop)
//全局变量
Vue.prototype.$config=config;
Vue.prototype.$IsPc=IsPC;
Vue.prototype.$ajax=network;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = message;
import vueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(vueAwesomeSwiper);

//使用vue-video
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

console.log(VideoPlayer)

setInterval(()=>{
  refreshToken()
},5400000)
new Vue({
    router,
    store,
  render: h => h(App),
}).$mount('#app')

// 百度统计
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?d9b1f27f64810be71c8b84dd6275982b";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

